import LeadQualificationWizard from "@/components/LeadQualificationWizard";

const Qualify = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-secondary to-background">
      <LeadQualificationWizard />
    </div>
  );
};

export default Qualify;
